import React, { useEffect, useState } from 'react';
import { validation } from '../../../shared/form-validations';
import { textInput, selectField, datePicker } from '../../../shared/form-elements'
import { connect, useDispatch, useSelector } from "react-redux";
import { reduxForm, Field, change  } from "redux-form";
import { Button, Modal } from 'react-bootstrap';
import CloseButton from 'react-bootstrap/CloseButton'
import { TextField } from '@mui/material';
import { DateTimePicker } from '@mui/x-date-pickers';
import moment from 'moment';

function ContentGroupContentForm(props) {
  const { handleSubmit, handleCloseForm, stages, dueDateInitialize, loading} = props

  return (
    <Modal
      show={true}
      onHide={handleCloseForm}
      size={"sm"}
      className="new-content-group-modal"
      centered
    >
      <Modal.Body>
        <form onSubmit={ (e) => loading ? null : handleSubmit(e) }>
          <div className="mb-12px">
            <Field
              name="name"
              type="text"
              autoFocus
              label="Card Title"
              placeholder='Add card title...'
              component={textInput}
              input_class_name="form-control h-30px"
            />
          </div>
          <div className="mb-12px">
            <Field
              name="stage_id"
              options={stages}
              label="Stage"
              blank_label="Select stage"
              input_class_name="h-30px"
              component={selectField}
            />
          </div>
          <div className="mb-12px">
              <label>Due Date</label>
              <Field
                name="due_date"
                component={datePicker}
                dueDateInitialize={dueDateInitialize}
                due_date={true}
                input_class_name="h-30px"
              />
          </div>
          <div className="d-grid">
            <Button
              variant="success"
              type="submit"
              disabled={loading}
              size={'sm'}
              className={'fw-500 h-30px mb-6px'}
            >
              Add
            </Button>
            <Button
              onClick={handleCloseForm}
              variant="transparent"
              size={'sm'}
              className={'fw-500 h-30px'}
            >
              Cancel
            </Button>

          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
}

ContentGroupContentForm =  reduxForm({
  form: 'content_group_form',
  enableReinitialize : true
})(ContentGroupContentForm);

const mapStateToProps = (state, ownProps) => {
  return {
    loading: state.content_group.content_group_loading
  };
};

export default connect(mapStateToProps, {})(ContentGroupContentForm);
